import IntlMessages from "../../../../util/IntlMessages";
import { Button, Divider } from "../../../BP2Components";
import { Icon_GoBack } from "../../../BP2Components/Icons/icons";
import { setUrlTo } from "../../GeneralScripts";
import { Icon_Comment } from "../../../BP2Components/Icons/icons";
import { useSelector } from "react-redux";
import Timer from "../../Timer";
import projectConfig from "../../../../projectConfig.json";
import "./MessageItemHeader.less";

const MessageItemHeader = ({ currentProcessStep, onCommentsButtonClick, commentsPosition }) => {
   const { backUrl }: any = useSelector(({ formsv2 }) => formsv2);

   return (
      <header className="message-item-header">
         <Button
            buttonType="default"
            className="message-item-header__goBack-button"
            onClick={() => {
               setUrlTo(backUrl || "/cases/inbox");
            }}
         >
            <Icon_GoBack fill="var(--first)" />
         </Button>
         <div className={"message-item-header__title-wrapper"}>
            {projectConfig.formConfig.showCaseTitle && currentProcessStep?.name && (
               <h4 className={`message-item-header__title-wrapper__title`}>
                  {currentProcessStep.name}
               </h4>
            )}
            {/* change it after we get info about deadline from backend in step */}
            {/* {"Invalid date" === "Invalid date" && (
               <p className={`p3 message-item-header__title-wrapper__deadline`}>
                  <span>
                     <IntlMessages id="email.writeMailRecipient" />:
                  </span>{" "}
                  {"00-00-0000"}
               </p>
            )} */}
         </div>
         {currentProcessStep && !projectConfig?.hideTimer === true && (
            <Timer
               instanceId={currentProcessStep?.instanceId}
               instanceStepId={currentProcessStep?.stepId}
            />
         )}
         {commentsPosition === 2 && !projectConfig?.hideCommentsButton && (
            <>
               <Divider type="vertical" className="comments-divider" />
               <div className="comments-position-2">
                  <Button buttonType="primary" onClick={onCommentsButtonClick}>
                     <Icon_Comment fill="currentColor" stroke="none"></Icon_Comment>
                  </Button>
               </div>
            </>
         )}
      </header>
   );
};

export default MessageItemHeader;
